import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { emptyTeam, Team } from "../../../../interfaces/team";
import { getTeamSingle } from "../../../../services/team";
import { getSeasonOptions } from "../../../../services/season";
import { Season } from "../../../../interfaces/season";
import { createStaffTeamSeason, getStaffOptions, getStaffTeamSeason } from "../../../../services/staff";
import { Staff, StaffTeamSeason } from "../../../../interfaces/staff";
import DataTable from "react-data-table-component";
import { LoadingSpinner } from "../../../general/loading-spinner";
import { tableStyles, getPaginationOptions } from "../../../../util/data-table";

interface ManagementTeamStaffProps {
    id: number;
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function ManagementTeamStaff(props: ManagementTeamStaffProps) {
    const [loaded, setLoaded] = useState(false);
    const [seasons, setSeasons] = useState<Season[]>([]);
    const [selectedSeasonId, setSelectedSeasonId] = useState();
    const [staff, setStaff] = useState<Staff[]>([]);
    const [team, setTeam] = useState<Team>(emptyTeam);
    const [staffTeamSeason, setStaffTeamSeason] = useState<StaffTeamSeason[]>([]);
    const [showAdd, setShowAdd] = useState(false);

    useEffect(() => {
        Promise.all([
            getSeasonOptions(),
            getTeamSingle(props.id),
        ]).then((response: any) => {
            setSeasons(response[0].data);            
            setTeam(response[1].data);
            getStaffOptions(response[1].data.club_id)
                .then((responseStaff: any) => {
                    setStaff(responseStaff.data);
                    setLoaded(true);
                });
        });
    }, []);

    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            staff_id: event.target.staff_id.value,
            team_id: team.id,
            season_id: selectedSeasonId
        }
        createStaffTeamSeason(body)
            .then(response => {
                if (response.data.status == 1) {
                    const newStaffTeamSeason = [
                        response.data.data,
                        ...staffTeamSeason
                    ];
                    setStaffTeamSeason(newStaffTeamSeason);
                    setShowAdd(false);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    const handleAddNew = (event: any) => {
        event.preventDefault();
        setShowAdd(true);
    }

    const handleCloseAddNew = (event: any) => {
        event.preventDefault();
        setShowAdd(false);
    }

    const handleEdit = (event: any) => {
        event.preventDefault();
        // setSelectedId(event.currentTarget.dataset.id);
        // setShowEdit(true);
    }

    const handleDelete = (event: any) => {
        event.preventDefault();
        // setSelectedId(event.currentTarget.dataset.id);
        // setShowDelete(true);
    }


    const handleSeasonChange = (event: any) => {
        event.preventDefault();
        setSelectedSeasonId(event.target.value);
        if (event.target.value.length > 0) {
            getStaffTeamSeason(team.id, event.target.value)
                .then((response: any) => {
                    setStaffTeamSeason(response.data);
                });
        } else {
            setStaffTeamSeason([]); 
        }
    }

    const CustomActions = (row: any) => (
        <span>
            {/*<a href="#" className="icon-link edit" title={ t("Edit") } onClick={ handleEdit } data-id={ row.row.id }>
                <i className="bi bi-pencil-square"></i>
            </a>*/}
            <a href="#" className="icon-link delete" title={ t("Delete") } onClick={ handleDelete } data-id={ row.row.id }>
                <i className="bi bi-trash"></i>
            </a>
        </span>
    );

    const columns = [
        {
            id: 'id',
            name: '#',
            style: { maxWidth: '80px' },
            selector: (row: any) => row.id,
            sortable: true
        },
        {
            id: 'staff_name',
            name: t('staff'),
            selector: (row: any) => row.staff_name,
            sortable: true
        },
        /*{
            id: 'actions',
            name: t("actions"),
            cell: (row: any) => <CustomActions row={row} />,
        }*/
    ];
    
    return (
        <Modal className="admin-team-players-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("team_staff") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { !loaded && 
                    <LoadingSpinner />
                }
                { loaded &&
                    <div className="form-container">
                        <div className="filters">
                            <Form.Group className="mb-3" controlId="season_id">
                                <Form.Label aria-required="true">{ t("season") }</Form.Label>
                                <Form.Select aria-label={ t("season") } name="season_id" required
                                    onChange={ handleSeasonChange }>
                                    <option value="">{ t("select_season") }</option>
                                    { seasons.map((s: Season) => {
                                        return <option key={ 'season-' + s.id } value={ s.id }>{ s.name }</option>;
                                    })}
                                </Form.Select>
                            </Form.Group>
                        </div>
                        { selectedSeasonId &&
                            <div className="subtable-container">
                                <DataTable
                                    columns={ columns }
                                    data={staffTeamSeason}
                                    // selectableRows={ true }
                                    // selectableRowsHighlight={ true }
                                    responsive={ true }
                                    striped={ true }
                                    highlightOnHover={ true }
                                    defaultSortFieldId={ 'staff_name' }
                                    defaultSortAsc={ false }
                                    pagination={ true }
                                    customStyles={ tableStyles }
                                    paginationComponentOptions={ getPaginationOptions() }
                                />
                            </div>
                        }
                        {/* !showAdd && selectedSeasonId &&
                            <a className="player-add-new" href="#" onClick={ handleAddNew }>
                                <i className="bi bi-plus-circle"></i>
                            </a>
                        */}
                        {/* showAdd && selectedSeasonId &&
                            <Form onSubmit={ handleSave } className="add-staff">
                                <Form.Group controlId="team_id">
                                    <Form.Control type="hidden" name="team_id" required 
                                        defaultValue={ team.id } />
                                </Form.Group>
                                <Form.Group controlId="team_id">
                                    <Form.Control type="hidden" name="team_id" required 
                                        defaultValue={ selectedSeasonId } />
                                </Form.Group>
                                <div className="fields">
                                    <Form.Group className="mb-3" controlId="staff_id">
                                        <Form.Label aria-required="true">{ t("staff") }</Form.Label>
                                        <Form.Select aria-label={ t("staff") } required>
                                            <option value="">{ t("select_staff") }</option>
                                            { staff.map((a: Staff) => {
                                                if (staffTeamSeason.findIndex((ats: StaffTeamSeason) => ats.staff_id == a.id) == -1) {
                                                    return <option key={ 'staff-' + a.id } value={ a.id }>{ a.name }</option>;
                                                }
                                            })}
                                        </Form.Select>
                                    </Form.Group>
                                </div>
                                <div className="actions">
                                    <Button type="submit" variant="primary">
                                        { t("Save") }
                                    </Button>
                                    <Button variant="secondary" onClick={ handleCloseAddNew }>
                                        { t("Close") }
                                    </Button>
                                </div>
                            </Form>
                        */}
                    </div>
                }
            </Modal.Body>
        </Modal>
    );
}
